import { NavLink, Outlet } from "react-router-dom";

export function AdminLayout() {
  const link = ({ isActive }: { isActive: boolean }) =>
    `px-3 py-1.5 rounded-full text-sm transition ${
      isActive ? "bg-ink text-cream" : "text-ink-soft hover:text-ink hover:bg-cream-dark"
    }`;
  return (
    <div className="mt-6">
      <h2 className="font-display font-black text-3xl mb-1">admin</h2>
      <p className="text-ink-soft mb-5 text-sm">be careful in here.</p>
      <nav className="flex gap-1.5 mb-6 border-b border-ink/10 pb-2">
        <NavLink to="/admin/users" className={link}>users</NavLink>
        <NavLink to="/admin/jobs" className={link}>jobs</NavLink>
        <NavLink to="/admin/complaints" className={link}>complaints</NavLink>
        <NavLink to="/admin/analytics" className={link}>analytics</NavLink>
      </nav>
      <Outlet />
    </div>
  );
}
